import React from 'react';
import useAuth from '../hooks/useAuth';
import Button from '@mui/material/Button';
import { toast, ToastContainer } from 'react-toastify';
import { useParams } from 'react-router';
import { Grid, TextField } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import { adminResetUserPassword } from '../../services/admin';

export const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};

export const AdminResetPassword = () => {
	const { getToken } = useAuth();
	let { id: profileId } = useParams();

	const [search, setSearch] = useSearchParams();

	const [newPassword, setNewPassword] = React.useState('');
	const [confirmNewPassword, setConfirmNewPassword] = React.useState('');
	const [passwordResetComplete, setPasswordResetComplete] =
		React.useState(false);
	const [profileName, setProfileName] = React.useState('');

	React.useEffect(() => {
		setProfileName(search.get('firstName') + ' ' + search.get('lastName'));
	}, []);

	const onSubmit = async () => {
		if (newPassword.length === 0) {
			toast.error('Password has zero characters', {
				timeOut: 1000,
			});
			return;
		}
		if (newPassword !== confirmNewPassword) {
			toast.error('Passwords do not match', {
				timeOut: 1000,
			});
			return;
		}
		let auth = getToken();
		if (auth) {
			try {
				let response = await adminResetUserPassword(
					auth.token,
					profileId,
					newPassword
				);
				if (response.data.errors) {
					toast.error(
						'There was an error in resetting password. Please try after sometime.',
						{
							timeOut: 1000,
						}
					);
					return;
				}
				setPasswordResetComplete(true);
			} catch (error) {
				console.error('error in resetting password', error);
				toast.error(
					'There was an error in resetting password. Please try after sometime.',
					{
						timeOut: 1000,
					}
				);
			}
		}
	};

	return (
		<>
			<ToastContainer />
			<div className='container-fluid mt-1 mb-1'>
				<div className='row home-row'>
					<ToastContainer />
					<h3>Reset Password</h3>
					<Grid container style={{ width: 500 }}>
						{!passwordResetComplete ? (
							<>
								<p>Reset password for user {profileName}</p>
								<Grid item xs={12} style={{ margin: 5 }}>
									<TextField
										label={'Password'}
										name={'password'}
										fullWidth
										type='password'
										value={newPassword}
										placeholder={'Enter new Password'}
										onChange={(event) =>
											setNewPassword(event.target.value)
										}
									/>
								</Grid>
								<Grid item xs={12} style={{ margin: 5 }}>
									<TextField
										label={'Confirm Password'}
										name={'confirm-password'}
										fullWidth
										type='password'
										value={confirmNewPassword}
										placeholder={'Enter new Password'}
										onChange={(event) =>
											setConfirmNewPassword(
												event.target.value
											)
										}
									/>
								</Grid>
								<Grid item xs={12} style={{ margin: 5 }}>
									<Button
										style={{
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
										}}
										type='submit'
										variant='contained'
										onClick={onSubmit}
									>
										Submit
									</Button>
								</Grid>
							</>
						) : (
							<Grid item xs={12} style={{ margin: 5 }}>
								<p>
									Password Reset Complete for {profileName}.
									Continue to{' '}
									<Link
										to={'/administratorpath/home'}
										style={{
											color: 'blue',
											border: 'inherit',
											textDecoration: 'none',
										}}
									>
										{'Admin Home'}
									</Link>{' '}
								</p>
							</Grid>
						)}
					</Grid>
				</div>
			</div>
		</>
	);
};
